import { render, staticRenderFns } from "./BatchItemAlternateStores.vue?vue&type=template&id=3a2789db"
import script from "./BatchItemAlternateStores.vue?vue&type=script&lang=js"
export * from "./BatchItemAlternateStores.vue?vue&type=script&lang=js"
import style0 from "./BatchItemAlternateStores.vue?vue&type=style&index=0&id=3a2789db&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports